import { cn } from '../../lib/utils'
import type { LeadStatus, LeadSource } from '@1130-studio/shared'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'violet' | 'lime' | 'white'
  className?: string
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  const variants = {
    default: 'bg-white/5 text-text-secondary border-white/10',
    success: 'bg-accent-green/10 text-accent-green border-accent-green/20',
    warning: 'bg-accent-orange/10 text-accent-orange border-accent-orange/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    info: 'bg-accent-blue/10 text-accent-blue border-accent-blue/20',
    violet: 'bg-accent-violet/10 text-accent-violet border-accent-violet/20',
    lime: 'bg-accent-lime/10 text-accent-lime border-accent-lime/20',
    white: 'bg-white/10 text-white border-white/20',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide border backdrop-blur-sm',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  )
}

// Lead status badge
const statusConfig: Record<LeadStatus, { label: string; variant: BadgeProps['variant'] }> = {
  new: { label: 'Новая', variant: 'lime' },
  bd_assigned: { label: 'Назначена', variant: 'info' },
  call_scheduled: { label: 'Созвон', variant: 'violet' },
  call_done: { label: 'Созвон проведён', variant: 'violet' },
  qualified: { label: 'Квалифицирована', variant: 'info' },
  estimation: { label: 'Оценка', variant: 'warning' },
  converted: { label: 'Конвертирована', variant: 'success' },
  lost: { label: 'Потеряна', variant: 'danger' },
}

export function LeadStatusBadge({ status }: { status: LeadStatus }) {
  const config = statusConfig[status] || { label: status, variant: 'default' }
  return <Badge variant={config.variant}>{config.label}</Badge>
}

// Lead source badge
const sourceConfig: Record<LeadSource, { label: string; variant: BadgeProps['variant'] }> = {
  website: { label: 'Сайт', variant: 'lime' },
  telegram: { label: 'Telegram', variant: 'info' },
  manual: { label: 'Вручную', variant: 'default' },
  referral: { label: 'Реферал', variant: 'violet' },
}

export function LeadSourceBadge({ source }: { source: LeadSource }) {
  const config = sourceConfig[source] || { label: source, variant: 'default' }
  return <Badge variant={config.variant}>{config.label}</Badge>
}
